import { MouseEvent, TransitionEvent, useCallback, useRef } from 'react';
import parse from 'html-react-parser';

import { CloseBtn, CloseIcon, Inner, StarsIcon, Title, Tooltip, Wrapper } from './Side.styles';

interface SideProps {
  widgetTitle: string;
  isTooltipOpen: boolean;
  closeBtn?: boolean;
  closeInitTooltip: (e: MouseEvent) => void;
  toggleHover: (state: boolean) => void;
  onTooltipHidden: () => void;
  tooltipText: string;
  onClick: () => void;
}

const OPEN_TOOLTIP_MAX_WIDTH = 999;

export const Side = ({
  widgetTitle,
  isTooltipOpen,
  closeBtn,
  closeInitTooltip,
  toggleHover,
  tooltipText,
  onTooltipHidden,
  onClick,
}: SideProps) => {
  const isFirstRenderRef = useRef(true);

  const onMouseEnter = useCallback(() => toggleHover(true), [toggleHover]);

  const onMouseLeave = useCallback(() => toggleHover(false), [toggleHover]);

  const onTransitionEnd = (e: TransitionEvent) => {
    const maxWidth = parseInt(window.getComputedStyle(e.target as HTMLElement).maxWidth);

    if (maxWidth !== OPEN_TOOLTIP_MAX_WIDTH) {
      onTooltipHidden();
    }
  };

  return (
    <Wrapper onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Inner isTooltipOpen={isTooltipOpen} onTransitionEnd={onTransitionEnd}>
        <Title>
          <StarsIcon />
          {parse(widgetTitle)}
        </Title>
        {tooltipText && <Tooltip>{parse(tooltipText)}</Tooltip>}
      </Inner>

      {isTooltipOpen && closeBtn && (
        <CloseBtn isFirstRender={isFirstRenderRef.current} onClick={closeInitTooltip}>
          <CloseIcon />
        </CloseBtn>
      )}
    </Wrapper>
  );
};
